"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentAndClassPerformanceHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var DpStudentAndClassPerformanceHeader_styled_1 = require("./DpStudentAndClassPerformanceHeader.styled");
var DpStudentAndClassPerformanceHeader = function () {
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsx)(DpStudentAndClassPerformanceHeader_styled_1.StyledStudentAndClassPerformanceHeader, { children: (0, jsx_runtime_1.jsx)("h3", { className: "h4", children: t('studentAndClassPerformance.title') }) }));
};
exports.DpStudentAndClassPerformanceHeader = DpStudentAndClassPerformanceHeader;
exports.default = exports.DpStudentAndClassPerformanceHeader;
